import { ApiService } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AccessionsState } from "shared/reducers/frontLoaderReducers";
import { createAsyncSaga, AsyncSagaAction } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.retrieveLisAccession>[0];
export const getAccession = createAsyncSaga(
  LIS.ACCESSION.GET.REQUEST,
  LIS.ACCESSION.GET.SUCCESS,
  LIS.ACCESSION.GET.ERROR,
  ({ id }: GetArgs) => `lis/accessions/${id}/retrieve`,
  ApiService.retrieveLisAccession
) as AsyncSagaAction<GetArgs>;

type CreateArgs = Parameters<typeof ApiService.createLisAccession>[0];
export const createAccession = createAsyncSaga(
  LIS.ACCESSION.CREATE.REQUEST,
  LIS.ACCESSION.CREATE.SUCCESS,
  LIS.ACCESSION.CREATE.ERROR,
  () => "lis/accessions/create",
  ApiService.createLisAccession
) as AsyncSagaAction<CreateArgs>;

type UpdateArgs = Parameters<typeof ApiService.partialUpdateLisAccession>[0];
export const updateAccession = createAsyncSaga(
  LIS.ACCESSION.UPDATE.REQUEST,
  LIS.ACCESSION.UPDATE.SUCCESS,
  LIS.ACCESSION.UPDATE.ERROR,
  ({ requestBody }: UpdateArgs) => {
    const keys = Object.keys(requestBody || {}).join(",");
    return `lis/accessions/update/${keys}`;
  },
  ApiService.partialUpdateLisAccession,
  {
    skipDuplicates: false,
    bufferDuplicates: true,
  }
) as AsyncSagaAction<UpdateArgs>;

type DeleteArgs = Parameters<typeof ApiService.destroyLisAccession>[0];
export const deleteAccession: AsyncSagaAction<DeleteArgs> = createAsyncSaga(
  LIS.ACCESSION.DELETE.REQUEST,
  LIS.ACCESSION.DELETE.SUCCESS,
  LIS.ACCESSION.DELETE.ERROR,
  ({ id }: DeleteArgs) => `lis/accessions/${id}/delete`,
  ApiService.destroyLisAccession,
  {
    stateConditionFn: (
      { accessions }: { accessions: AccessionsState },
      { id }: DeleteArgs
    ) => !accessions[id].completed_at,
  }
) as AsyncSagaAction<DeleteArgs>;

type PrintArgs = Parameters<typeof ApiService.printLisAccession>[0];
export const printAccession = createAsyncSaga(
  LIS.ACCESSION.PRINT.REQUEST,
  LIS.ACCESSION.PRINT.SUCCESS,
  LIS.ACCESSION.PRINT.ERROR,
  ({ id }: PrintArgs) => `lis/accessions/${id}/print`,
  ApiService.printLisAccession
) as AsyncSagaAction<PrintArgs>;
